<template>
<div>
  <div v-if="skills && skills.length > 0">
    <heading>{{$t('profile.skills')}}</heading>
    <skills-list :skills="skills" :editable="false" />
  </div>
</div>
</template>

<script>
import Heading from '@/components/general/heading'
import SkillsList from '@/components/skills/skills-list'

export default {
  components: { Heading, SkillsList },
  props: {
    skills: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseeker-skills.vue